import { Configuration, RedirectRequest } from "@azure/msal-browser"

// Config object to be passed to Msal on creation

const tenantId = import.meta.env.VITE_APP_TENANT_ID
const clientId = import.meta.env.VITE_APP_CLIENT_ID
const redirectUri = import.meta.env.VITE_APP_REDIRECT_URL
const microSoftLogin = import.meta.env.VITE_APP_MICROSOFT_LOGIN
const microSoftGraphMe = import.meta.env.VITE_APP_MICROSOFT_GRAPH_ME

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: `${microSoftLogin}${tenantId}/`,
    redirectUri: redirectUri,
    postLogoutRedirectUri: null,
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
  },
}

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: RedirectRequest = {
  scopes: [`${clientId}/.default`],
}

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: `${microSoftGraphMe}`,
}
